import { countryCodeList } from '@mqd/volt-base';

const findCountryByName = (name) => countryCodeList.find((el) => el.name === name);

export { findCountryByName };
